import { useEffect } from 'react'
import { useSetAtom } from 'jotai'
import { useAccountsContext } from 'hooks/context/useAccountsContext'
import { useBvnkNetworkConnectionsQuery } from 'hooks/queries/BvnkNetwork/useBvnkNetworkConnectionsQuery'
import {
  bvnkNetworkConnectionsAtom,
  isFetchingConnectionsAtom,
  isFetchingConnectionsErrorAtom,
} from 'pages/BvnkNetwork/atoms/bvnkNetworkAtoms'

export const useSetBvnkNetworkConnections = (accountReference: string) => {
  const { accountCapabilities } = useAccountsContext()
  const setBvnkNetworkConnections = useSetAtom(bvnkNetworkConnectionsAtom)
  const setIsFetchingBvnkNetwork = useSetAtom(isFetchingConnectionsAtom)
  const setIsFetchingConnectionsError = useSetAtom(isFetchingConnectionsErrorAtom)

  const {
    data: bvnkNetworkConnections,
    isFetching: isFetchingConnections,
    isError: isFetchingConnectionsError,
  } = useBvnkNetworkConnectionsQuery(
    {
      accountReference,
    },
    !!accountReference && accountCapabilities?.isBvnkNetworkCapabilityEnabled
  )

  useEffect(() => {
    setBvnkNetworkConnections(bvnkNetworkConnections)
    setIsFetchingBvnkNetwork(isFetchingConnections)
    setIsFetchingConnectionsError(isFetchingConnectionsError)
  }, [bvnkNetworkConnections, isFetchingConnections, isFetchingConnectionsError])
}
